import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge
} from 'reactstrap';
import moment from 'moment';
import $ from 'jquery';
import AppPage from '../../views/AppPage/'

class ViewEvent extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			eventtype : '',
			_message : '',
			alertClass :'',
			posts : [],
			_redirect : false,
		}
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('event/geteventbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					evename : res[0]['eventname'],
					content : res[0]['content'],
					edate: res[0]['eventdate'],
					etime : res[0]['eventtime'],
					evetype : res[0]['type'],
					url : res[0]['image']
				});
			}
		});
	}
	
	checkedate(dat){
		
		var ed = new Date(dat);
		var momentObj = moment(ed);
		var momentString = momentObj.format('MMMM DD , Y');
		return momentString;
	}
	
	checkstatus(dat){
		
		var sta = [];
		var today = new Date();
		var edata = new Date(dat);
		 
		if(edata > today){
			 
			sta.push(<Badge className="mr-1" color="success">Pending</Badge>);
		}
		else{
			 
			sta.push(<Badge className="mr-1" color="danger">Completed</Badge>);
		}
		return sta;
	}
	
	html2text(html) {
		var tag = document.createElement('div');
		tag.innerHTML = html;
		
		return tag.innerText;
	}

  render() {
	
	if(this.state._redirect){
		
		return (<Redirect to={'/events/event'} />);
	}
	
	this.state.id = this.props.match.params.id;
	
    return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>Events</strong>
						<Button outline color="primary" className="btn-right" onClick={this.onBack}>Back</Button>
					</CardHeader>
					<CardBody>
					<Table responsive>
						<tbody>
							<tr>
								<td width="150">Event Name</td><td> : </td><td>{this.state.evename}</td>
							</tr>
							<tr>
								<td width="150">Event Date</td><td> : </td><td>{this.checkedate(this.state.edate)}</td>
							</tr>
							<tr>
								<td width="150">Event Time</td><td> : </td><td>{this.state.etime}</td>
							</tr>
							<tr>
								<td width="150">Event Status</td><td> : </td><td>{this.checkstatus(this.state.edate)}</td>
							</tr>
							<tr>
								<td width="150">Event Description</td><td> : </td><td>{this.html2text(this.state.content)}</td>
							</tr>
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default ViewEvent;


// WEBPACK FOOTER //
// ./src/events/Event/ViewEvent.js